import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const surveyStatsAction = createAsyncThunk(
    'survey-stats',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/survey-stats`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const surveyStatsSlice = createSlice({
    name: 'survey-stats',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(surveyStatsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(surveyStatsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(surveyStatsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const surveyStatsReducer = surveyStatsSlice.reducer
